import * as actions from '../actions/types';

const initialState = {
  step: 1,
  maxStep: 2,
  submitted: false,
  updated: false
};

function setStep(formState, action) {
  return {
    ...formState,
    step: Math.min(action.step, formState.maxStep)
  };
}

function toggleSubmitted(formState, action) {
  return {
    ...formState,
    submitted: !formState.submitted
  };
}

function applicationSaved(formState, action) {
  return {
    ...formState,
    updated: false
  }
}

function applicationUpdated(formState, action) {
  return {
    ...formState,
    updated: true
  }
}

export const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_STEP:
      return setStep(state, action);
    case actions.TOGGLE_SUBMITTED:
      return toggleSubmitted(state, action);
    case actions.UPDATE_APPLICATION_SUCCESS:
      return applicationSaved(state, action);
    case actions.UPDATE_BASIC_INFO:
      return applicationUpdated(state, action);
    default:
      return state;
  }
};

export default formReducer;